//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Accordion = function Accordion() {
  return import('~/components/molecules/Accordion.vue');
};

export default {
  name: 'NavItemFolders',
  components: {
    Accordion: Accordion
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};